import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';

/**
 * Custom exception.
 */
export default class ServerErrorResponseException extends AbstractException {
	public readonly exceptionType = ExceptionTypeEnum.serverErrorResponse;
	public readonly name = 'ServerErrorResponseException';
	public readonly serverResponse: Response;

	/**
	 * Class constructor.
	 *
	 * @param response Server response.
	 * @param message Message.
	 */
	constructor(response: Response, message?: string) {
		super(
			`Failed to fetch from "${response.url}". Server responded with ${response.status} ${
				response.statusText
			}.${message ? ` Error: ${message}` : ''}`
		);
		this.serverResponse = response;
	}
}
